import { faGithub } from '@fortawesome/free-brands-svg-icons'
import {
  faArrowLeft,
  faArrowUpRightFromSquare,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import '../SASS/work.scss'

const Work = () => {
  return (
    <section className="work-container">
      <div className="work-nav">
        <Link to="/">
          <FontAwesomeIcon icon={faArrowLeft} /> Home
        </Link>
        <div>
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
        </div>
      </div>
      <article className="work">
        <div className="project-card">
          {data.map((item) => {
            return (
              <div key={item.id} className="card">
                <div className="card-img">
                  <img src={item.img} alt="" />
                  <div className="card-link">
                    <FontAwesomeIcon icon={faGithub} />
                    <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </article>
    </section>
  )
}

export default Work

const data = [
  {
    id: 1,
    img: './images/1.jpg',
  },
  {
    id: 2,
    img: './images/2.jpg',
  },
  {
    id: 3,
    img: './images/3.jpg',
  },
  {
    id: 4,
    img: './images/4.jpg',
  },
  {
    id: 5,
    img: './images/7.jpg',
  },
  {
    id: 6,
    img: './images/6.jpg',
  },
]
